module.exports = __webpack_public_path__ + "img/valve-factory-view.jpg";